import formsCache from "../formsCache";

function useFormsCache(key) {
  const cache = formsCache;

  const value = cache.get(key);

  function setValue(value) {
    cache.put(key, value);
  }

  function clearCache() {
    cache.clear();
  }

  return [value, setValue, clearCache];
}

export default useFormsCache;
